import { useState } from "react";
import { Card, CardBody, CardHeader, Button, Label } from "reactstrap";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../api/api";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

const RESEND_MESSAGES = {
  confirmation_email_resend_success: {
    icon: "success",
    title: "Correo reenviado",
    text: "El correo de verificacion fue reenviado al usuario.",
  },
  confirmation_email_already_confirmed: {
    icon: "info",
    title: "Su correo se encuentra autenticado con exito",
    text: "Este usuario ya confirmo su correo, no se envio uno nuevo.",
  },
  confirmation_email_resend_too_soon: {
    icon: "warning",
    title: "Espera un momento",
    text: "Debes esperar 2 minutos antes de reenviar el correo nuevamente.",
  },
};

export const CardUserInfo = ({ user }) => {
  const [isResending, setIsResending] = useState(false);
  const { postData } = useDataFetch();
  const { mutateAsync: resendConfirmation } = postData(
    `/users/resend-confirmation/${user.id}`,
    {}
  );

  const handleResendConfirmation = async () => {
    try {
      setIsResending(true);
      const response = await resendConfirmation({});
      Swal.fire(
        RESEND_MESSAGES[response?.message] ??
          RESEND_MESSAGES.confirmation_email_resend_success
      );
    } catch (error) {
      Swal.fire(
        RESEND_MESSAGES[error?.message] ?? {
          icon: "error",
          title: "No se pudo reenviar",
          text: "Ocurrio un error al reenviar el correo de verificacion.",
        }
      );
    } finally {
      setIsResending(false);
    }
  };

  const identityUrl = user.identityDocument
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.identityDocument}`
    : null;

  const rutUrl = user.rutDocument
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.rutDocument}`
    : null;
    
  const bankCertificate = user.bankCertificate
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.bankCertificate}`
    : null;

  return (
    <Card>
      <CardHeader>Información del Usuario</CardHeader>
      <CardBody>
        <p><strong>Nombre:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Telefono:</strong> {user.cellphone}</p>
        <p><strong>Código Multyhealth:</strong> {user.multyhealth_code}</p>
        <p><strong>Rol:</strong> {user.role}</p>
        <p><strong>Estado:</strong> {user.status ? "Activo" : "Inactivo"}</p>
        <p className="d-flex align-items-center gap-2">
          <strong>Confirmado:</strong> {user.is_confirmed ? "Sí" : "No"}
          {!user.is_confirmed && (
            <Button
              color="primary"
              outline
              size="sm"
              disabled={isResending}
              onClick={handleResendConfirmation}
            >
              <i className="fa fa-envelope me-1" />
              {isResending ? "Reenviando..." : "Reenviar verificación"}
            </Button>
          )}
        </p>
        <p><strong>Creado:</strong> {new Date(user.createdAt).toLocaleString()}</p>

        {(identityUrl || rutUrl || bankCertificate) && (
          <>
            <Label className="mt-3 mb-1 d-block">Documentos</Label>
            <div className="d-flex gap-2">
              {identityUrl && (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  href={identityUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-download me-1" />
                  Documento de Identidad
                </Button>
              )}
              {rutUrl && (
                <Button
                  color="secondary"
                  outline
                  size="sm"
                  href={rutUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-download me-1" />
                  RUT
                </Button>
              )}
              {bankCertificate && (
                <Button
                  color="success"
                  outline
                  size="sm"
                  href={bankCertificate}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-download me-1" />
                  Certificado Bancario
                </Button>
              )}
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};
